import { RootState } from "../../../redux-store";

export const selectIsOnline = (state: RootState) => state.app.network.isOnline;
